import type { CropBox } from '@/shared/config/types';
import type { IconNames } from '@/shared/ui/Icon/Icon.types';

import type { DentalPhotoEditTool, ImageTransformState } from './types';

export const DEFAULT_TRANSFORM_STATE: ImageTransformState = {
  baseRotation: 0,
  freeRotation: 0,
  flipHorizontal: false,
  cropBox: null,
  zoom: 1,
  panX: 0,
  panY: 0,
};

export const ZOOM_MIN = 0.5;
export const ZOOM_MAX = 5;
export const ZOOM_STEP = 0.25;
export const ROTATION_STEP = 90;
export const FREE_ROTATION_MIN = -180;
export const FREE_ROTATION_MAX = 180;

export const PHOTO_MAX_WIDTH = 820;

// Default crop area: 80% of image centered with 10% margins
export const DEFAULT_CROP_BOX: CropBox = {
  x: 0.1,
  y: 0.1,
  width: 0.8,
  height: 0.8,
};

// Reserve height for header + footer when calculating crop display
export const FOOTER_RESERVE_HEIGHT = 150;

export const TOOL_TO_ICON: Record<DentalPhotoEditTool, IconNames> = {
  crop: 'crop',
  rotate: 'turn',
  straighten: 'angle',
  zoom: 'zoom',
  mirror: 'mirror',
};

// Optical size adjustments per tool icon.
// Icons have different viewBoxes and internal padding,
// so we tweak rendered sizes for visual consistency.
export const TOOL_TO_ICON_SIZE: Record<DentalPhotoEditTool, number> = {
  crop: 32,
  rotate: 32,
  straighten: 28,
  zoom: 32,
  mirror: 32,
};

export const EDIT_TOOLS: DentalPhotoEditTool[] = [
  'crop',
  'rotate',
  'straighten',
  'zoom',
  'mirror',
];
